import React, { useState, useEffect, useRef } from 'react';
import { PowerBIEmbed, } from 'powerbi-client-react';
import { models, Report } from 'powerbi-client';
import { toastr } from "react-redux-toastr";
import api from '../../axios/api';

const Powerbi = (props: any) => {

  const [reportId, setReportId] = useState<string>('')
  const [embedUrl, setEmbedUrl] = useState<string>('')
  const [accessToken, setAccessToken] = useState<string>('')
  const slicerConfigured = useRef<boolean>(false)

  const i18nextLng = localStorage.getItem('i18nextLng') || 'pt-BR';

  useEffect(() => {
    getPowerBiData()
  }, [])

  const getPowerBiData = async () => {
    try {
      const response = await api.get('/powerbi/signurl')
      setReportId(response.data.data.reportId)
      setEmbedUrl(response.data.data.embedUrl)
      setAccessToken(response.data.data.accessToken)
    } catch (err: any) {
      console.log('err', err)
      if (err.response?.data?.message) {
        toastr.error('Error', err.response.data.message);
      } else {
        toastr.error('Error', 'Something went wrong');
      }
      console.log('err', err)
    }
  }

  const handlePageChanged = () => {
    slicerConfigured.current = false;
  }

  const handleReportRender = async () => {
    if (slicerConfigured.current) {
      return;
    }
    const report = (window as any).report as Report;

    if (report) {
      try {
        const pages = await report.getPages();

        for (const page of pages) {
          const visuals = await page.getVisuals();

          for (const visual of visuals) {
            if (visual.type === 'slicer') {
              try {
                const slicerState = await visual.getSlicerState();

                const target = slicerState?.filters?.[0]?.target as any;
                if (target?.table === "Idiomas" && target?.column === "Lang") {

                  await visual.setSlicerState({
                    filters: [{
                      $schema: "http://powerbi.com/product/schema#basic",
                      target: {
                        table: "Idiomas",
                        column: "Lang"
                      },
                      operator: "In",
                      values: [i18nextLng],
                      filterType: models.FilterType.Basic,
                    }]
                  });

                  console.log('Slicer de idioma configurado com sucesso');
                  slicerConfigured.current = true;
                }
              } catch (err: any) {
                if (err?.message !== 'visualConfigIsNotInitialized') {
                  console.log('Erro ao definir slicer:', err);
                }
              }
            }
          }
        }
      } catch (err) {
        console.log('Erro ao configurar slicers:', err);
      }
    }
  }

  return (
    <div style={{
      height: 'calc(100% + 40px)',
      width: 'calc(100% + 40px)',
      marginTop: '-20px',
      marginLeft: '-20px',
    }}>
      <PowerBIEmbed
        embedConfig={{
          type: 'report',   // Supported types: report, dashboard, tile, visual, qna, paginated report and create
          id: reportId,
          embedUrl: embedUrl,
          accessToken: accessToken,
          tokenType: models.TokenType.Embed, // Use models.TokenType.Aad for SaaS embed
          settings: {
            panes: {
              filters: {
                expanded: false,
                visible: false
              }
            },
            background: models.BackgroundType.Transparent,
            layoutType: models.LayoutType.Custom,
            customLayout: {
              displayOption: models.DisplayOption.FitToWidth
            }
          }
        }}

        eventHandlers={
          new Map([
            ['loaded', function () { console.log('Report loaded'); }],
            ['rendered', handleReportRender],
            ['error', function (event) { console.log(event?.detail); }],
            ['visualClicked', () => console.log('visual clicked')],
            ['pageChanged', handlePageChanged],
          ])
        }

        cssClassName={"reportClass"}

        getEmbeddedComponent={(embeddedReport) => {
          (window as any).report = embeddedReport as Report;
        }}
      />
    </div>
  );
}

export default Powerbi;
